//import
import './build/anchor.js';
import { createApp } from 'vue';

/**============================================================
*   [Animation] observerでアニメーション用クラス付与
*   target : .p-animation-observer
============================================================*/
import observerShowObj from './build/observerShowObj';
const observerElem = document.getElementsByClassName('p-animation-observer');
const createObserveObj = () => {
  if (!observerElem.length) return;
  for (let i = 0; i < observerElem.length; i++) {
    new observerShowObj(observerElem[i]);
  }
}
document.addEventListener('DOMContentLoaded', createObserveObj, false);

/**============================================================
*   [共通] アコーディオングループ
*   target : .js-toggle-accordion
============================================================*/
import ToggleAccordion from './build/ToggleAccordion.vue';
const ToggleAccordionElem = document.getElementsByClassName('js-toggle-accordion');
const createToggleAccordionObj = () => {
  if (!ToggleAccordionElem.length) return;
  for (let i = 0; i < ToggleAccordionElem.length; i++) {
    createApp(ToggleAccordion).mount(ToggleAccordionElem[i]);
  }
}
document.addEventListener('DOMContentLoaded', createToggleAccordionObj, false);

/**============================================================
*   [共通] パネル型記事スライダー
*   target : .p-archive-centered-slider
============================================================*/
import ArchiveCenteredSlider from './build/ArchiveCenteredSlider';
const ArchiveCenteredSliderElem = document.getElementsByClassName('p-archive-centered-slider');
const createArchiveCenteredSliderObj = () => {
  if (!ArchiveCenteredSliderElem.length) return;
  for (let i = 0; i < ArchiveCenteredSliderElem.length; i++) {
    new ArchiveCenteredSlider(ArchiveCenteredSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createArchiveCenteredSliderObj, false);

/**============================================================
*   [viewport] 375px以下画面は縮小
============================================================*/
(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth >= 375
        ? 'width=device-width,initial-scale=1'
        : 'width=375';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();
})();

/**============================================================
*   [MicroModal]
============================================================*/
import MicroModal from 'micromodal';
MicroModal.init({
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
  onShow: ()=>{
    document.documentElement.classList.add('is-modal-opened');
  },
  onClose: ()=>{
    document.documentElement.classList.remove('is-modal-opened');
  }
});
